<template>
  <div class="menu" :class="{ menu_mobile: isMobile }">
    <div class="menu__wrap">

      <div v-if="isMobileMenu" class="menu__mobile">
        <div class="filter">
          <div
            class="filter__item"
            :class="{ filter__item_active: filterType === 'img' }"
            @click="filterCount('img')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" v-bind:svg-inline="''" v-bind:class="'filter__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.1 1.3L6.4 3H5C3.3 3 2 4.3 2 6v8c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3h-1.4l-1.7-1.7c-.2-.2-.5-.3-.8-.3H8.8c-.3 0-.5.1-.7.3z" fill="none" stroke="#000d1a" stroke-width="2"/><circle cx="11" cy="10" r="2.5" fill-rule="evenodd" clip-rule="evenodd" fill="#000d1a"/></svg>
            <div class="filter__info">display</div>
          </div>
          <div
            class="filter__item"
            :class="{ filter__item_active: filterType === 'video' }"
            @click="filterCount('video')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" v-bind:svg-inline="''" v-bind:class="'filter__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="10.6" cy="10" r="9" fill="none" stroke="#000" stroke-width="2"/><path d="M9.3 6.5l4.6 3.1c.2.2.3.5.1.7 0 .1-.1.1-.1.1l-4.6 3.1c-.2.2-.5.1-.7-.1-.1-.1-.1-.2-.1-.3V6.9c0-.3.2-.5.5-.5.2 0 .2.1.3.1z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
            <div class="filter__info">video</div>
          </div>
          <div
            class="filter__item"
            :class="{ filter__item_active: filterType === 'game' }"
            @click="filterCount('game')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18" v-bind:svg-inline="''" v-bind:class="'filter__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.5 2h5c1.8-1.9 6-1.1 6.6 2.4.2.9.3 1.7.6 2.8.1.4.4 2.1.5 2.5 0 .2 0 .2.1.5.2 1 .4 1.9.6 2.8.8 3.8-3 5.4-5 2.6-.7-1-.9-1.2-1-1.3h0c-.1-.1-.1-.2-.3-.4-.3-.5-1.1-.9-1.6-.9H9c-.5 0-1.3.4-1.6.8-.2.2-.2.3-.3.4h0c-.1.1-.3.4-1 1.3-2.1 2.9-5.8 1.2-5-2.6.7-3.6 1.3-6.5 1.7-8.6C3.5.9 7.7.1 9.5 2z" fill="none" stroke="#000" stroke-width="2" stroke-miterlimit="10"/><path d="M12 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
            <div class="filter__info">interactive</div>
          </div>
        </div>

        <div
          v-bar
          class="menu__cont"
          :class="{menu__cont_mobile: isMobile}"
          @click="shift()">

          <div>
            <router-link
              class="menu__link"
              v-for='creative in currentCreativesMobile'
              :class="{
                img: creative.type.img,
                video: creative.type.video,
                game: creative.type.game,
                menu__link_active: currentPage.params.m_id === creative.id,
                hide: creative.id === 'landing' || creative.id === 'editorialContent'
              }"
              :key='creative.name'
              :to="{
                name: 'Mobile',
                params: {
                  m_id: creative.id,
                }
              }"
            >
              <div class="menu__link-text">{{ creative.name }}</div>
              <div class="menu__icons">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" v-if="creative.type.img" v-bind:svg-inline="''" v-bind:class="'menu__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.1 1.3L6.4 3H5C3.3 3 2 4.3 2 6v8c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3h-1.4l-1.7-1.7c-.2-.2-.5-.3-.8-.3H8.8c-.3 0-.5.1-.7.3z" fill="none" stroke="#000d1a" stroke-width="2"/><circle cx="11" cy="10" r="2.5" fill-rule="evenodd" clip-rule="evenodd" fill="#000d1a"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" v-if="creative.type.video" v-bind:svg-inline="''" v-bind:class="'menu__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="10.6" cy="10" r="9" fill="none" stroke="#000" stroke-width="2"/><path d="M9.3 6.5l4.6 3.1c.2.2.3.5.1.7 0 .1-.1.1-.1.1l-4.6 3.1c-.2.2-.5.1-.7-.1-.1-.1-.1-.2-.1-.3V6.9c0-.3.2-.5.5-.5.2 0 .2.1.3.1z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18" v-if="creative.type.game" v-bind:svg-inline="''" v-bind:class="'menu__icon menu__icon_game'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.5 2h5c1.8-1.9 6-1.1 6.6 2.4.2.9.3 1.7.6 2.8.1.4.4 2.1.5 2.5 0 .2 0 .2.1.5.2 1 .4 1.9.6 2.8.8 3.8-3 5.4-5 2.6-.7-1-.9-1.2-1-1.3h0c-.1-.1-.1-.2-.3-.4-.3-.5-1.1-.9-1.6-.9H9c-.5 0-1.3.4-1.6.8-.2.2-.2.3-.3.4h0c-.1.1-.3.4-1 1.3-2.1 2.9-5.8 1.2-5-2.6.7-3.6 1.3-6.5 1.7-8.6C3.5.9 7.7.1 9.5 2z" fill="none" stroke="#000" stroke-width="2" stroke-miterlimit="10"/><path d="M12 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
              </div>
            </router-link>
          </div>
        </div>

<!--        <div v-else
          class="menu__cont menu__cont_mobile"
          @click="shift()">

            <router-link
              class="menu__link"
              v-for='creative in currentCreativesMobile'
              :class="{
                img: creative.type.img,
                video: creative.type.video,
                game: creative.type.game,
                menu__link_active: currentPage.params.m_id === creative.id,
                hide: creative.id === 'landing' || creative.id === 'editorialContent'
              }"
              :key='creative.name'
              :to="{
                name: 'Mobile',
                params: {
                  m_id: creative.id,
                }
              }"
            >
              <div class="menu__link-text">{{ creative.name }}</div>
              <div class="menu__icons">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18" v-if="creative.type.img" v-bind:svg-inline="''" v-bind:class="'menu__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.1 1.3L6.4 3H5C3.3 3 2 4.3 2 6v8c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3h-1.4l-1.7-1.7c-.2-.2-.5-.3-.8-.3H8.8c-.3 0-.5.1-.7.3z" fill="none" stroke="#000d1a" stroke-width="2"/><circle cx="11" cy="10" r="2.5" fill-rule="evenodd" clip-rule="evenodd" fill="#000d1a"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20" v-if="creative.type.video" v-bind:svg-inline="''" v-bind:class="'menu__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="10.6" cy="10" r="9" fill="none" stroke="#000" stroke-width="2"/><path d="M9.3 6.5l4.6 3.1c.2.2.3.5.1.7 0 .1-.1.1-.1.1l-4.6 3.1c-.2.2-.5.1-.7-.1-.1-.1-.1-.2-.1-.3V6.9c0-.3.2-.5.5-.5.2 0 .2.1.3.1z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 18" v-if="creative.type.game" v-bind:svg-inline="''" v-bind:class="'menu__icon menu__icon_game'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.5 2h5c1.8-1.9 6-1.1 6.6 2.4.2.9.3 1.7.6 2.8.1.4.4 2.1.5 2.5 0 .2 0 .2.1.5.2 1 .4 1.9.6 2.8.8 3.8-3 5.4-5 2.6-.7-1-.9-1.2-1-1.3h0c-.1-.1-.1-.2-.3-.4-.3-.5-1.1-.9-1.6-.9H9c-.5 0-1.3.4-1.6.8-.2.2-.2.3-.3.4h0c-.1.1-.3.4-1 1.3-2.1 2.9-5.8 1.2-5-2.6.7-3.6 1.3-6.5 1.7-8.6C3.5.9 7.7.1 9.5 2z" fill="none" stroke="#000" stroke-width="2" stroke-miterlimit="10"/><path d="M12 9c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
              </div>
            </router-link>

        </div>-->

      </div>

      <div v-if="isDesktopMenu" class="menu__desktop" @click="shift()">
        <router-link
          class="menu__link"
          :class="{
            menu__link_active: currentPage.params.d_id === creative.id
          }"
          v-for='creative in creativesDesktop'
          :key='creative.id'
          :to="{
            name: 'Desktop',
            params: {
              d_id: creative.id
            }
          }">
            <div class="menu__link-text">{{ creative.name }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import { mapGetters } from 'vuex';
import Vuebar from 'vuebar';
import Vue from 'vue';

Vue.use(Vuebar);

export default {
  name: 'mainMenu',
  data() {
    return {
      img: false,
      video: false,
      game: false,
      hideMobileMenu: false,
      hideDesktopMenu: true,
      isMobile,
      filterType: '',
    };
  },
  computed: {
    ...mapGetters({
      creativesMobile: ['getMobileCreatives'],
      creativesDesktop: ['getDesktopCreatives'],
    }),
    currentCreativesMobile() {
      let arr = [];
      if (!this.filterType) {
        arr = this.creativesMobile;
      } else {
        arr = this.creativesMobile.filter(
          (creative) => (Object.keys(creative.type).find(
            (key) => creative.type[key] && key === this.filterType,
          )),
        );
        this.routerFilteredLinkInList(arr);
      }
      return arr;
    },
    currentPage() {
      return this.$route;
    },
    isMobileMenu() {
      return this.$router.currentRoute.name === 'Mobile';
    },
    isDesktopMenu() {
      return this.$router.currentRoute.name === 'Desktop';
    },
  },
  methods: {
    filterCount(type) {
      if (this.filterType === type) {
        this.filterType = '';
      } else {
        this.filterType = type;
      }
    },
    routerFilteredLinkInList(arr) {
      if (arr.length > 0
        && arr.every((elem) => elem.id !== this.$router.currentRoute.params.m_id)) {
        this.$router.push({
          name: 'Mobile',
          params: { m_id: arr[0].id },
        }).catch((err) => {
          throw new Error(`Problem handling something: ${err}.`);
        });
      }
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>
hover()
  @media (hover: hover)
    {block}

.hide
  display none !important

.filter
  margin-bottom 20px
  text-align center
  &__item
    position relative
    display inline-block
    width 30%
    height 40px
    margin-right 8px
    border-radius 8px
    border 1px solid #CFDAE6
    text-align center
    vertical-align middle
    box-sizing border-box
    cursor pointer
    &:before
      content ''
      display inline-block
      width 0
      height 100%
      vertical-align middle
    &:last-child
      margin-right 0
    &_active
      background-color #F5F7FA
      cursor default
    +hover()
      &:hover
        background-color #F5F7FA
        & ^[0]__info
          display block
  &__icon
    display inline-block
    width 20px
    height auto
    vertical-align middle
    pointer-events none
  &__info
    position absolute
    left 50%
    bottom -27px
    transform translateX(-50%)
    z-index 9999999
    display none
    padding 6px 8px
    background-color #818181
    border-radius 5px
    color white
    font-size 12px
    line-height 12px
    font-family 'Roboto', sans-serif
    font-weight 500

.menu
  height 100%
  &hide
    display none
  &__mobile,
  &__wrap
    height 100%
  &__cont
    width 100%
    height calc(100% - 60px)
    padding-right 15px
    overflow hidden
    // &_mobile
    //   position fixed
    //   padding 15px 20px 20px
    //   left 0
    //   box-sizing border-box
  &__link
    width 100%
    display block
    margin-bottom 4px
    padding 12px
    text-align left
    text-decoration none
    border-radius 8px
    box-sizing border-box
    -webkit-tap-highlight-color transparent
    overflow hidden
    font-size 0
    line-height 0
    color black
    &:hover
      background-color #F5F7FA
    &_active
      background-color #FF5500
      color white
      &:hover
        background-color #FF5500
        color white
        cursor default
    &-text
      float left
      display inline-block
      vertical-align middle
      font-size 14px
      line-height 20px
      font-family 'Roboto', sans-serif
      font-weight 500
  &__icon
    width 20px
    height 20px
    display inline-block
    margin-right 8px
    pointer-events none
    opacity .2
    &_game
      width 23px
    &:last-child
      margin-right 0
  &__icons
    display inline-block
    vertical-align middle
    float right
  &__desktop
    height calc(100vh - 320px)
    overflow auto

</style>
